var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditMessage = function SvgEditMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.857 3.155h7.367v1.34H.857zm0-1.34h7.367V.478H.857zm0 5.358h4.688v-1.34H.857zM10.91 5.077l.475-.475a.667.667 0 0 1 .945 0l.475.475a.667.667 0 0 1 0 .944l-.475.476zm-.476.476L6.885 9.102v1.42h1.42l3.55-3.55z"
  })));
};
export default SvgEditMessage;